import React from 'react';
import AccountTabs from '../../Account/AccountTabs';
import ManageAccountPanel from '../../Account/ManageAccountPanel';
import styles from './Profile.module.scss';

const ManageAccount = () => (
    <main className={styles.page}>
        <section className={styles.hero}>
            <div className={styles.heroContent}>
                <span className={styles.heroTag}>Account</span>
                <h1 className={styles.heroTitle}>Manage account</h1>
                <p className={styles.heroSubtitle}>
                    Review the impact and deactivate your CombatTV account when you are ready.
                </p>
            </div>
        </section>

        <AccountTabs />

        <section className={styles.section}>
            <ManageAccountPanel />
        </section>
    </main>
);

export default ManageAccount;
